export type NormalizeAssetUrlOpts = {
  /**
   * What to return when the input is empty/blank.
   * Useful for UI placeholders.
   */
  fallback?: string;
};

/**
 * Canonical asset URL normalizer used across the app.
 *
 * - Keeps absolute URLs (any scheme: https:, blob:, data:, etc)
 * - Keeps protocol-relative URLs (//cdn.example.com/...)
 * - Normalizes legacy relative prefixes (../, ./)
 * - Ensures a leading slash for app-relative paths
 */
export function normalizeAssetUrl(url?: string | null, opts?: NormalizeAssetUrlOpts): string {
  const u = String(url ?? '').trim();
  if (!u) return String(opts?.fallback ?? '');

  // Keep any absolute URL (http(s), blob:, data:, etc).
  if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(u)) return u;
  // Keep protocol-relative URLs like //cdn.example.com/x.mp4
  if (u.startsWith('//')) return u;

  // Legacy admin sometimes stored paths like "../media/..." or "./media/..."
  let v = u;
  while (v.startsWith('../')) v = v.slice(3);
  while (v.startsWith('./')) v = v.slice(2);

  if (v.startsWith('/')) return v;
  return '/' + v.replace(/^\/+/, '');
}


